import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

export interface Case {
    transaction_amount: number;
    case_code: string;
    total_risk_score: number;
    priority: string;
    status: string;
    created_at: string; /** is actually a date represented as a string */
    transaction_blocked: false;
    customer_name: string;
    customer_id: number;
    transaction_id: number;
    notes: string;
    due_date: string; /** is actually a date represented as a string */
    complexity: string;
    report: string;
    customer_code: string;
    case_classification: string;
}

export interface ServerCaseResponse {
    count: number;
    results: Case[];
    data_info: { low: Case[], medium: Case[], high: Case[] };
    data?: [];
    limit: number;
    total?: number;
    page: number;
    last_page: number;
    loading?: boolean;
}

export interface CaseUser {
    id: number;
    first_name: string;
    last_name: string;
    email: string;
}

export interface ServerUserStatisticsResponse {
    data_info: {
        personal_statistics: {
            solved: { cases: number, percentage: number },
            open: { cases: number, percentage: number },
            reported: { cases: number, percentage: number },
            overdue: { cases: number, percentage: number }
        },
        case_statistics: {
            open: number,
            closed: number,
            open_reported: number,
            closed_reported: number
        }
    };
}

export interface AssignCase {
  message: string;
  data_info: {
    code: string;
    assigned_to: string;
    due_date: string
  };
}

@Injectable({
    providedIn: 'root'
})
export class CaseManagerService {
    httpOptions = {
        headers: new HttpHeaders({     // Add extra HTTP options here
            'Content-Type': 'application/json'
        })
    };
    serverUrl = environment.serverUrl;

    constructor(public httpClient: HttpClient) { }

    async getAllCases() {
        return this.httpClient.get<ServerCaseResponse>(this.serverUrl + '/transaction/case/list?all=True').toPromise();
    }
    async getPendingCases(pageNumber) {
        if (pageNumber) {
            return this.httpClient.get<ServerCaseResponse>(this.serverUrl + '/transaction/case/not_assigned?page=' + pageNumber).toPromise();
        } else {
            return this.httpClient.get<ServerCaseResponse>(this.serverUrl + '/transaction/case/not_assigned').toPromise();
       }

    }
    async getAssignedCases(pageNumber = 1, limit=10) {
        return this.httpClient.get<ServerCaseResponse>
        (`${this.serverUrl}/transaction/case/assigned?page=${pageNumber}&limit=${limit}`).toPromise();
      }
      // async getAssignedCases(params) {
      //   return this.httpClient.get<ServerCaseResponse>(this.serverUrl + '/transaction/case/list/?assigned=True').toPromise();
      // }

    async getCase(caseId: string) {
        return this.httpClient.get<Case>(this.serverUrl + '/transaction/case?code=' + caseId).toPromise();
    }
    async getStatistics(frequencyParam: string) {
      // TODO: Remove when API for daily freq_type will be ready
      if (frequencyParam === 'daily') {
        frequencyParam = 'weekly';
      }

      return this.httpClient.get<ServerUserStatisticsResponse>
          (this.serverUrl + '/transaction/statistics_user?freq_type=' + frequencyParam).toPromise();
    }
    async getCaseUsers() {
        return this.httpClient.get<CaseUser[]>(this.serverUrl + '/user/list/').toPromise();
    }

    // getCaseList(caseCode): Observable<any> {
    //     return this.httpClient.get(this.serverUrl + '/transaction/case/linkedcaselist?case_code=' + caseCode)
    //         .pipe(map((res: any) => this.transformCases(res.data_info)));
    // }

    // private transformCases(cases: any): Array<any> {
    //     return (cases || []).map((item) => {
    //         return {
    //             name: item.customer_name,
    //             image: '',
    //             id: item.case_code.slice(4),
    //             amount: '',
    //             created_at: new Date(item.created_at),
    //             decision: item.status,
    //             link: '',
    //         };
    //     });
    // }

    assignCaseToCurrentUser(caseId: string) {
        const request = { code: caseId };
        return this.httpClient.post(this.serverUrl + '/transaction/case/assign/', request, this.httpOptions);
    }

    assignCaseToUser(caseId: string, userId: number): Observable<AssignCase> {
        const request = { code: caseId, user_id: userId };
        return this.httpClient.post<AssignCase>(this.serverUrl + '/transaction/case/assign/', request, this.httpOptions);
    }
}
